import { AnyObject } from "types";

export default class Coupon {
  id: number;
  code: string;
  activations: number;
  validity: Date | null;
  usersNumber: number;
  cost = 0;
  constructor(properties: AnyObject = {}) {
    this.id = properties.id || 0;
    this.code = properties.code?.toUpperCase() || "";
    this.activations = properties.activations || 0;
    this.usersNumber = properties.usersNumber || 1;
    this.validity = properties.validity || null;
    if (properties.cost) {
      let parseCost = properties.cost;
      if (typeof parseCost === "string")
        parseCost = parseCost.replace(",", "").replace("$", "");
      this.cost = parseFloat(parseCost);
    }
  }
  asJSON(): AnyObject {
    return {
      code: this.code.toUpperCase(),
      activations: this.activations,
      usersNumber: this.usersNumber,
      validity: this.validity,
      cost: this.cost,
    };
  }
  minValidity(): Date {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
    return currentDate;
  }
}
